/* eslint-disable better-mutation/no-mutation */

import initData from 'init-data';
import TEXT_STRINGS from 'tradera/apps/my-tradera/app/constants/text-strings';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSearching: false,
    page: {},
    error: false,
    initData: {
        environment: initData.environment || '',
        version: initData.environment || '',
        title: initData.title || '',
        description: initData.description || '',
    },
    splitTests: initData.splitTests || null,
    memberAlias: initData ? initData.memberAlias : '',
    memberFirstName: initData ? initData.memberFirstName : '',
    memberId: initData ? initData.memberId : '',
    memberLastName: initData ? initData.memberLastName : '',
    memberCountryCodeIso2: initData ? initData.memberCountryCodeIso2 : null,
    memberMessagingParticipation: true,
    mobileMenu: false,
    mobileActions: false,
};

const slice = createSlice({
    name: 'my-tradera',
    initialState,
    reducers: {
        searching: (state, { payload }) => {
            state.isSearching = payload;
        },
        error: (state, { payload }) => {
            state.error =
                payload === true ? TEXT_STRINGS.ERRORS.GENERIC : payload;
        },
        openModal: (state, { payload }) => {
            state.openModal = payload;
        },
        setBreakPoint: (state, { payload }) => {
            state.breakpoint = payload;
        },
        mobileMenu: (state, { payload }) => {
            state.mobileMenu =
                payload && payload === false ? false : !state.mobileMenu;
        },
        setTranslatedRouteInformation: (state, { payload }) => {
            state.page = payload;
        },
    },
});

export const selectMyTraderaState = (state) => state.views.myTradera.myTradera;

export default slice.reducer;

export const {
    openModal,
    searching,
    error,
    mobileMenu,
    setBreakPoint,
    setTranslatedRouteInformation,
} = slice.actions;
